const EVENT_TYPES = {
  1: 'My Shifts', // blankish, red, blue, green, orange, purple, yellow
  2: 'Not My Shifts', // blankish, red, blue, green, orange, purple, yellow **only can see this group security key
  3: 'Open Shifts', // same color no matter who you are (WHITE)
  4: 'Pending Request Open Shifts', // blankish, red, blue, green, orange, purple, yellow
  5: 'Pending Call Off Shifts', // blankish, red, blue, green, orange, purple, yellow
  6: 'Appointments Shifts', // blankish, red, blue, green, orange, purple, yellow
};
const EVENT_COLORS = {
  red: [210, 40, 40],
  blue: [120, 170, 215],
  green: [70, 190, 120],
  orange: [250, 145, 70],
  purple: [155, 140, 235],
  yellow: [235, 230, 170],
  white: [255, 255, 255],
  defaultMute: [220, 220, 220],
  neonGreen: [57, 255, 20],
};

const SchedulingCalendar = (function () {
  // DOM
  let ScheduleCalendar;
  let locationDropdownEle;
  let employeeDropdownEle;
  let shiftTypeDropdownEle;
  let shiftTypeNote;
  let pubUnpubButtonEle;
  let copyShiftsButtonEle;
  let newShiftButtonEle;
  let openShiftYesRadio;
  let openShiftNoRadio;

  // DATA
  let schedules;
  let appointments;
  let calendarEvents;
  let eventsArray;
  let calendarAppointments;
  let locations;
  let employees;
  let employeesByVendorLocation;

  // GLOBALS
  let currentCalView;
  let selectedLocationId;
  let selectedEmployeeId;
  let selectedShiftType;
  let viewOptionShifts;

  function sortEmployeeString(a, b) {
    const [aLast, aFirst] = a.text.split(',').map(s => s.trim());
    const [bLast, bFirst] = b.text.split(',').map(s => s.trim());

    const lastCmp = aLast.localeCompare(bLast, undefined, { sensitivity: 'base' });
    if (lastCmp !== 0) return lastCmp;

    return aFirst.localeCompare(bFirst, undefined, { sensitivity: 'base' });
  }
  function showSuccessFailPopup(success, message, removeOverlay = true) {
    if (success) {
      if (!message) message = 'SAVED';
      successfulSave.show(message);
      setTimeout(function () {
        successfulSave.hide(removeOverlay);
      }, 1000);
    } else {
      if (!message) message = 'ERROR SAVING';
      failSave.show(message);
      setTimeout(function () {
        failSave.hide(removeOverlay);
      }, 1000);
    }
  }
  function abbreviateAppointment(str) {
    if (!str || str === '') return '';

    const map = {
      appointment: 'appt',
    };

    return str
      .split(' ')
      .map(word => map[word.toLowerCase()] || word)
      .join(' ');
  }

  // Calendar
  //-----------------------------------------------------------------------
  function getEventType(personID, callOffStatus, requestShiftStatus) {
    if (!personID) {
      if (!callOffStatus && (requestShiftStatus === 'D' || requestShiftStatus === '')) {
        return { type: EVENT_TYPES[3], id: 3 };
      }

      if (requestShiftStatus === 'P') {
        return { type: EVENT_TYPES[4], id: 4 };
      }
    }

    if (personID.toString() === $.session.PeopleId) {
      if (callOffStatus === 'P') {
        return { type: EVENT_TYPES[5], id: 5 };
      }

      return { type: EVENT_TYPES[1], id: 1 };
    }

    return { type: EVENT_TYPES[2], id: 2 };
  }
  function getEventColor(typeId, color) {
    if (typeId === 3) {
      // open shifts
      return EVENT_COLORS.white;
    }

    if (!color) {
      return EVENT_COLORS.defaultMute;
    }

    return EVENT_COLORS[color];
  }
  function formatServiceDate(serviceDate, dateScheduled) {
    let date = serviceDate ? serviceDate : dateScheduled;
    return date.split(' ')[0];
  }
  function formatDescription(firstName, lastName) {
    if (!lastName || !firstName) return '';

    return `${lastName}, ${firstName}`;
  }
  function getEventTotalTime(dirtyStart, dirtyEnd) {
    if (!dirtyStart || !dirtyEnd) return '';

    const [startHours, startMinutes, startSeconds] = dirtyStart.split(':').map(Number);
    const [endHours, endMinutes, endSeconds] = dirtyEnd.split(':').map(Number);

    const startTimeMilliseconds = (startHours * 3600 + startMinutes * 60 + startSeconds) * 1000;
    const endTimeMilliseconds = (endHours * 3600 + endMinutes * 60 + endSeconds) * 1000;

    let milliseconds = endTimeMilliseconds - startTimeMilliseconds;

    if (milliseconds < 0) {
      milliseconds += 24 * 3600 * 1000;
    }

    const hours = milliseconds / (1000 * 60 * 60);
    return hours === 0 ? '' : `(${parseFloat(hours.toFixed(2))})`;
  }
  function refilterEventsByAvailableLocations() {
    calendarEvents = eventsArray.filter(event => {
      const hasLoc = locations.find(loc => loc.locationId === event.locationId);
      return hasLoc ? true : false;
    });

    renderCalendarEvents();
  }
  async function getCalendarEvents(locationID = '%', peopleID = '%') {
    const tempschedules = (
      await _UTIL.fetchData('getSchedulesForSchedulingModuleNew', {
        locationId: locationID,
        personId: peopleID,
      })
    ).getSchedulesForSchedulingModuleNewResult;

    const tempschIds = new Set();
    schedules = tempschedules.filter(sch => {
      if (tempschIds.has(sch.shiftId)) {
        return false;
      } else {
        tempschIds.add(sch.shiftId);
        return true;
      }
    });

    const schIds = new Set();
    eventsArray = schedules
      .filter(sched => {
        const timeRegEx = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;
        const isStartTimeValid = timeRegEx.test(sched.startTime);
        const isEndTimeValid = timeRegEx.test(sched.endTime);

        const { type, id } = getEventType(
          sched.personID,
          sched.callOffStatus,
          sched.requestShiftStatus,
        );

        if (!isStartTimeValid || !isEndTimeValid || sched.serviceDate === '') {
          return false;
        }

        if (!type || (id === 2 && !$.session.schedulingSecurity)) {
          return false;
        }

        if (schIds.has(sched.shiftId)) {
          return false;
        } else {
          schIds.add(sched.shiftId);
          return true;
        }
      })
      .map(sch => {
        const { type, id } = getEventType(sch.personID, sch.callOffStatus, sch.requestShiftStatus);

        const serviceDate = formatServiceDate(sch.serviceDate, sch.dateScheduled);
        const startTime = `${serviceDate} ${sch.startTime}`;
        const endTime = `${serviceDate} ${sch.endTime}`;

        const length = getEventTotalTime(sch.startTime, sch.endTime);
        const description = formatDescription(sch.firstName, sch.lastName);
        const color = getEventColor(id, sch.color);

        // store on cache obj
        sch.typeId = id;
        sch.colorCode = color;
        sch.length = length;

        return {
          eventId: sch.shiftId,
          date: serviceDate,
          startTime: startTime,
          endTime: endTime,
          length: length,
          description: description,
          name: id === 3 ? 'Open Shift' : description,
          typeId: id,
          typeName: type,
          locationId: sch.locationId,
          locationName: sch.locationName,
          publishedDate: sch.publishDate,
          color: color,
          consumers: sch.consumerNames,
          personId: sch.personID,
        };
      });

    if (selectedLocationId === '%') {
      return eventsArray.filter(event => {
        const hasLoc = locations.find(loc => loc.locationId === event.locationId);
        return hasLoc ? true : false;
      });
    }

    return eventsArray;
  }
  function formatEndTimeForAppointments(endTimeObj) {
    const intlDateFull = new Intl.DateTimeFormat('en-US', {
      day: 'numeric',
      month: 'numeric',
      year: '2-digit',
      hour: 'numeric',
      minute: 'numeric',
      weekday: 'long',
      hour12: false,
    }).format(endTimeObj);

    const intlDate = new Intl.DateTimeFormat('en-US').format(endTimeObj);

    const timeString = `${intlDateFull.split(',')[2].split(' ')[1]}:00`;

    return `${intlDate} ${timeString}`;
  }
  async function getCalendarAppointments(locationID = '%') {
    appointments = (
      await _UTIL.fetchData('getScheduleApptInformationNew', { locationId: locationID })
    ).getScheduleApptInformationNewResult;

    const appointmentArray = appointments.map(appt => {
      const serviceDate = formatServiceDate(appt.serviceDate, appt.dateScheduled);
      const startTimeObj = new Date(`${serviceDate} ${appt.timeScheduled}`);
      const endTimeObj = dates.addHours(startTimeObj, 1);
      const startTime = `${new Intl.DateTimeFormat('en-US').format(startTimeObj)} ${
        appt.timeScheduled
      }`;
      const endTime = formatEndTimeForAppointments(endTimeObj);
      const color = getEventColor(6, appt.color);
      // const color = [57, 255, 20];

      // store on cache obj
      appt.shiftId = appt.medTrackingId;
      appt.typeId = 6;
      appt.colorCode = color;
      appt.length = '(1)';
      appt.startTime = startTime.split(' ')[1];
      appt.endTime = endTime.split(' ')[1];

      return {
        eventId: appt.medTrackingId,
        date: serviceDate,
        startTime: startTime,
        endTime: endTime,
        length: appt.length,
        description: abbreviateAppointment(appt.typeDescription),
        name: appt.consumerName,
        staffName: appt.takenToApptBy,
        typeId: appt.typeId,
        typeName: EVENT_TYPES[appt.typeId],
        locationId: appt.locationId,
        locationName: appt.locationName,
        publishedDate: appt.publishDate,
        color: color,
        timeScheduled: appt.timeScheduled,
      };
    });

    // if (selectedLocationId === '%') {
    //   return appointmentArray.filter(appt => {
    //     const hasLoc = locations.find(loc => loc.locationId === appt.locationId);
    //     return hasLoc ? true : false;
    //   });
    // }

    return appointmentArray;
  }
  function renderCalendarEvents() {
    if (selectedLocationId === '%') {
      ScheduleCalendar.renderGroupedEvents([...calendarEvents, ...calendarAppointments], {
        groupBy: 'locationId',
        groupName: 'locationName',
      });
    } else if (selectedEmployeeId === '%') {
      ScheduleCalendar.renderGroupedEvents([...calendarEvents, ...calendarAppointments], {
        groupBy: 'personId',
        groupName: 'name',
      });
    } else {
      ScheduleCalendar.renderEvents([...calendarEvents, ...calendarAppointments]);
    }
  }
  //
  function handleCalendarEventClick(eventTarget) {
    if (eventTarget.classList.contains('day') && document.body.classList.contains('mobileActive')) {
      const dateISO = eventTarget.dataset.date;
      const shiftIds = ScheduleCalendar.getShiftIdsByDay(dateISO);

      if (!shiftIds || !shiftIds.length) return;

      const targetEvents = [...appointments, ...schedules].filter(ev =>
        shiftIds.includes(ev.shiftId),
      );
      SchedulingShifts.showGroupPopup(targetEvents, dateISO);

      return;
    }

    if (eventTarget.classList.contains('eventCellGroupEle')) {
      const dayDiv = eventTarget.parentElement.parentElement;
      if (dayDiv.classList.contains('day')) {
        const dateISO = dayDiv.dataset.date;
        const shiftIds = ScheduleCalendar.getShiftIdsByDay(dateISO);

        if (!shiftIds || !shiftIds.length) return;

        const targetEvents = [...appointments, ...schedules].filter(ev =>
          shiftIds.includes(ev.shiftId),
        );
        SchedulingShifts.showGroupPopup(targetEvents, dateISO);
      }

      return;
    }

    if (eventTarget.classList.contains('eventCellEle')) {
      const eventTypeId = eventTarget.dataset.typeId;
      const shiftId = eventTarget.dataset.eventId;
      const targetEvent = [...appointments, ...schedules].find(ev => ev.shiftId == shiftId);

      SchedulingShifts.showPopup({
        eventTypeId,
        data: targetEvent,
        isCopy: false,
      });

      return;
    }

    if (eventTarget.classList.contains('copyShiftIcon')) {
      const dayCellEle = eventTarget.closest('.eventCellEle');
      const eventTypeId = dayCellEle.dataset.typeId;
      const shiftId = dayCellEle.dataset.eventId;
      const targetEvent = [...appointments, ...schedules].find(ev => ev.shiftId == shiftId);

      SchedulingShifts.showPopup({
        eventTypeId,
        data: { ...targetEvent },
        isCopy: true,
      });

      return;
    }
  }

  // MAIN DOM
  //-----------------------------------------------------------------------
  function populateLocationDropdown() {
    const dropdownData = locations
      .map(d => ({
        value: d.locationId,
        text: d.locationName,
      }))
      .filter(l => !l.id);

    dropdownData.unshift({
      value: '%',
      text: 'All',
    });

    dropdown.populate(locationDropdownEle, dropdownData, selectedLocationId);
  }
  function populateEmployeeGroupDropdown() {
    let locationEmployeeData = [];
    let otherEmployeeData = [];
    let currentSelectedEmployeeExists = false;
    let hasUserId = false;

    employeesByVendorLocation.forEach(employee => {
      if (employee.Person_Id === selectedEmployeeId) currentSelectedEmployeeExists = true;
      if (employee.Person_Id === $.session.PeopleId) hasUserId = true;

      if (employee.Preferred === 'Y') {
        locationEmployeeData.push({ value: employee.Person_Id, text: employee.EmployeeName });
      } else {
        otherEmployeeData.push({ value: employee.Person_Id, text: employee.EmployeeName });
      }
    });

    locationEmployeeData.sort((a, b) => {
      const textA = a.text.toUpperCase();
      const textB = b.text.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
    otherEmployeeData.sort((a, b) => {
      const textA = a.text.toUpperCase();
      const textB = b.text.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });

    const locationEmployeeGroup = {
      groupLabel: 'Preferred at This Location',
      groupId: 'scheduleLocationEmployee',
      dropdownValues: locationEmployeeData,
    };
    const otherEmployeeGroup = {
      groupLabel: 'Other Employees',
      groupId: 'scheduleOtherEmployee',
      dropdownValues: otherEmployeeData,
    };

    const groupDropdownData = [];
    if (locationEmployeeData.length > 0) {
      groupDropdownData.push(locationEmployeeGroup);
    }
    groupDropdownData.push(otherEmployeeGroup);

    if (selectedEmployeeId !== '%') {
      if (!currentSelectedEmployeeExists) {
        if (!hasUserId) {
          selectedEmployeeId = '%';
        } else {
          selectedEmployeeId = $.session.PeopleId;
        }
      }
    }

    dropdown.groupingPopulate({
      dropdown: employeeDropdownEle,
      data: groupDropdownData,
      nonGroupedData: [
        {
          value: '%',
          text: 'All',
        },
      ],
      defaultVal: selectedEmployeeId,
    });
  }
  function populateEmployeeDropdown() {
    if ($.session.schedulingSecurity && selectedLocationId !== '%') {
      populateEmployeeGroupDropdown();
      return;
    }

    let dropdownData = [];

    if ($.session.schedulingSecurity) {
      let currentSelectedEmployeeExists = false;
      let hasUserId = false;

      employees.forEach(d => {
        if (d.Person_Id === selectedEmployeeId) currentSelectedEmployeeExists = true;
        if (d.Person_Id === $.session.PeopleId) hasUserId = true;

        dropdownData.push({
          value: d.Person_Id,
          text: d.EmployeeName,
        });
      });

      dropdownData.sort(sortEmployeeString);

      if (!currentSelectedEmployeeExists && selectedEmployeeId !== '%') {
        if (!hasUserId) {
          selectedEmployeeId = '%';
        } else {
          selectedEmployeeId = $.session.PeopleId;
        }
      }
    } else {
      dropdownData.unshift({
        value: $.session.PeopleId,
        text: `${$.session.LName}, ${$.session.Name}`,
      });
    }

    dropdownData.unshift({
      value: '%',
      text: 'All',
    });

    if (viewOptionShifts === 'yes') {
      dropdownData.unshift({
        value: 'none',
        text: '(none)',
      });
    }

    dropdown.populate(employeeDropdownEle, dropdownData, selectedEmployeeId);
  }
  function buildLocationDropdown() {
    const dropdownEle = dropdown.build({
      dropdownId: 'locationDropdown',
      label: 'Location:',
      style: 'secondary',
    });

    dropdownEle.classList.add('mainLocationDropdown');

    dropdownEle.addEventListener('change', async event => {
      selectedLocationId = event.target.options[event.target.selectedIndex].value;

      if ($.session.schedulingSecurity && selectedLocationId !== '%') {
        employeesByVendorLocation = (
          await _UTIL.fetchData('getEmployeesByLocation', { locationId: selectedLocationId })
        ).getEmployeesByLocationResult;
      }

      populateEmployeeDropdown();

      const [eventsResp, appointmentsResp] = await Promise.all([
        getCalendarEvents(selectedLocationId, selectedEmployeeId),
        getCalendarAppointments(selectedLocationId),
      ]);

      calendarEvents = eventsResp;
      calendarAppointments = appointmentsResp;

      renderCalendarEvents();
    });

    return dropdownEle;
  }
  function buildEmployeeDropdown() {
    const dropdownEle = dropdown.build({
      dropdownId: 'employeeDropdown',
      label: 'Employee:',
      style: 'secondary',
    });

    dropdownEle.classList.add('mainEmployeeDropdown');

    dropdownEle.addEventListener('change', async event => {
      let reFilterOutOpenShifts = false;

      selectedEmployeeId = event.target.options[event.target.selectedIndex].value;

      const [eventsResp, appointmentsResp] = await Promise.all([
        getCalendarEvents(selectedLocationId, selectedEmployeeId),
        getCalendarAppointments(selectedLocationId),
      ]);

      calendarEvents = eventsResp;
      calendarAppointments = appointmentsResp;

      renderCalendarEvents();

      if (reFilterOutOpenShifts) {
        const filterCheck = value => value !== 3;
        ScheduleCalendar.filterEventsBy({ filterKey: 'typeId', filterCheck });
      }
    });

    return dropdownEle;
  }
  function updateShiftTypeNote(shiftCount) {
    shiftTypeNote.textContent = `Un-Published Shifts: ${shiftCount}`;

    if (shiftCount === 0) {
      shiftTypeNote.classList.remove('error');
    } else {
      shiftTypeNote.classList.add('error');
    }
  }
  function buildShiftTypeDropdown() {
    const shiftTypeWrap = document.createElement('div');
    shiftTypeWrap.classList.add('shiftTypeWrap');
    shiftTypeNote = document.createElement('p');
    shiftTypeNote.textContent = 'Un-Publishsed Shifts: 0';
    const dropdownEle = dropdown.build({
      dropdownId: 'shiftTypeDropdown',
      label: 'Show:',
      style: 'secondary',
    });

    dropdownEle.addEventListener('change', event => {
      selectedShiftType = event.target.options[event.target.selectedIndex].value;

      if (selectedShiftType === '0') {
        ScheduleCalendar.filterEventsBy({
          resetFilter: true,
          filterKey: 'publishedDate',
        });

        return;
      }

      const filterCheck = selectedShiftType === '1' ? value => !!value : value => !value;
      ScheduleCalendar.filterEventsBy({ filterKey: 'publishedDate', filterCheck });
    });

    selectedShiftType = '0';

    dropdown.populate(
      dropdownEle,
      [
        {
          value: '0',
          text: 'All Shifts',
        },
        {
          value: '1',
          text: 'Published Shifts',
        },
        {
          value: '2',
          text: 'Un-Published Shifts',
        },
      ],
      selectedShiftType,
    );

    shiftTypeWrap.appendChild(dropdownEle);
    shiftTypeWrap.appendChild(shiftTypeNote);

    return shiftTypeWrap;
  }
  function buildPubUnpubSchedulesButton() {
    const buttonEle = button.build({
      text: 'Publish / Un-Publish Schedules',
      classNames: ['pubUnpubButton'],
      style: 'secondary',
      type: 'contained',
    });

    buttonEle.addEventListener('click', e => {
      const pubUnpubCallback = async (data, pubOrUnpub) => {
        const success = (
          await _UTIL.fetchData('publishShift', {
            publish: pubOrUnpub,
            ...data,
          })
        ).publishShiftResult;

        showSuccessFailPopup(success);

        const [eventsResp, appointmentsResp] = await Promise.all([
          getCalendarEvents(selectedLocationId, selectedEmployeeId),
          getCalendarAppointments(selectedLocationId),
        ]);

        calendarEvents = eventsResp;
        calendarAppointments = appointmentsResp;
        renderCalendarEvents();
      };

      PublishUnpublishSchedules.showPopup(employees, locations, pubUnpubCallback);
    });

    return buttonEle;
  }
  function buildNewShiftButton() {
    const buttonEle = button.build({
      text: 'Add New Shift',
      classNames: ['newShiftButton'],
      style: 'secondary',
      type: 'contained',
    });

    buttonEle.addEventListener('click', e => {
      SchedulingShifts.showPopup({
        eventTypeId: '',
        data: null,
        isCopy: false,
      });
    });

    return buttonEle;
  }
  function buildCopyShiftsButton() {
    const buttonEle = button.build({
      text: 'Copy Shifts',
      classNames: ['copyShiftButton'],
      style: 'secondary',
      type: 'contained',
    });

    buttonEle.addEventListener('click', e => {
      CopyScheduleShifts.showPopup();
    });

    return buttonEle;
  }
  function buildOpenShiftViewToggleButton() {
    const radioContainer = document.createElement('div');
    radioContainer.classList.add('openShiftWrap');

    const radioTitle = document.createElement('p');
    radioTitle.innerText = 'Show Open Shifts';

    const radioDiv = document.createElement('div');
    openShiftYesRadio = input.buildRadio({
      text: 'Yes',
      id: 'yes',
      name: 'openShift',
      isChecked: viewOptionShifts === 'yes' ? true : false,
      attributes: [{ key: 'value', value: 'yes' }],
    });
    openShiftNoRadio = input.buildRadio({
      text: 'No',
      id: 'no',
      name: 'openShift',
      isChecked: viewOptionShifts === 'yes' ? false : true,
      attributes: [{ key: 'value', value: 'no' }],
    });
    radioDiv.appendChild(openShiftYesRadio);
    radioDiv.appendChild(openShiftNoRadio);

    radioDiv.addEventListener('change', async e => {
      viewOptionShifts = e.target.id.toLowerCase();

      if (!$.session.schedulingSecurity) {
        const includeOpenShiftLocations = viewOptionShifts === 'yes' ? 'Y' : 'N';
        locations = (
          await _UTIL.fetchData('getLocationDropdownForSchedulingNew', {
            showOpenShifts: includeOpenShiftLocations,
          })
        ).getLocationDropdownForSchedulingNewResult;
        populateLocationDropdown();
      }

      if (viewOptionShifts === 'no') {
        if (selectedEmployeeId === 'none') {
          selectedEmployeeId = $.session.PeopleId;
          renderCalendarEvents();
        } else {
          const filterCheck = value => value !== 3 && value !== 4;
          ScheduleCalendar.filterEventsBy({ filterKey: 'typeId', filterCheck });
        }
      } else {
        refilterEventsByAvailableLocations();
        ScheduleCalendar.filterEventsBy({ resetFilter: true, filterKey: 'typeId' });
      }

      populateEmployeeDropdown();
    });

    radioContainer.appendChild(radioTitle);
    radioContainer.appendChild(radioDiv);

    return radioContainer;
  }
  function buildFilter() {
    const accordionWrapEle = document.createElement('div');
    const accordionTriggerEle = document.createElement('div');
    const accordionContentEle = document.createElement('div');
    const contentWrapEle = document.createElement('div');

    accordionWrapEle.className = 'navAccordion';
    accordionTriggerEle.className = 'navAccordionTrigger';
    accordionContentEle.className = 'navAccordionContent closed';
    contentWrapEle.className = 'navAccordionContentWrapEle';

    accordionTriggerEle.innerHTML = `${icons.keyArrowDown} <p>Filter Calendar</p>`;

    accordionWrapEle.appendChild(accordionTriggerEle);
    accordionWrapEle.appendChild(accordionContentEle);
    accordionContentEle.appendChild(contentWrapEle);

    locationDropdownEle = buildLocationDropdown();
    employeeDropdownEle = buildEmployeeDropdown();
    shiftTypeDropdownEle = buildShiftTypeDropdown();
    const openShiftViewToggleEle = buildOpenShiftViewToggleButton();

    contentWrapEle.appendChild(locationDropdownEle);
    contentWrapEle.appendChild(employeeDropdownEle);
    contentWrapEle.appendChild(shiftTypeDropdownEle);
    contentWrapEle.appendChild(openShiftViewToggleEle);

    if (!$.session.schedulingSecurity) {
      contentWrapEle.removeChild(shiftTypeDropdownEle);

      //employeeDropdownEle.classList.add('disabled');
      input.disableInputField(employeeDropdownEle);
    }

    accordionTriggerEle.addEventListener('click', e => {
      accordionContentEle.classList.toggle('closed');
    });

    return accordionWrapEle;
  }
  function build() {
    const scheduleWrap = document.createElement('div');
    scheduleWrap.classList.add('scheduleWrap');

    const scheduleNav = document.createElement('div');
    scheduleNav.classList.add('scheduleNav');

    const scheduleFilter = buildFilter();

    const colRight = document.createElement('div');
    colRight.classList.add('colRight');

    newShiftButtonEle = buildNewShiftButton();
    copyShiftsButtonEle = buildCopyShiftsButton();
    pubUnpubButtonEle = buildPubUnpubSchedulesButton();

    if ($.session.schedulingSecurity) {
      colRight.appendChild(newShiftButtonEle);
      if ($.session.flag.copyShifts) {
        // Ticket #162055
        colRight.appendChild(copyShiftsButtonEle);
      }
      colRight.appendChild(pubUnpubButtonEle);
    }

    scheduleNav.appendChild(scheduleFilter);
    scheduleNav.appendChild(colRight);
    scheduleWrap.appendChild(scheduleNav);
    scheduleWrap.appendChild(ScheduleCalendar.rootEle);

    _DOM.ACTIONCENTER.innerHTML = '';
    _DOM.ACTIONCENTER.appendChild(scheduleWrap);

    ScheduleCalendar.renderCalendar();
  }

  function resetModule() {
    // DOM
    ScheduleCalendar = undefined;
    locationDropdownEle = undefined;
    employeeDropdownEle = undefined;
    shiftTypeDropdownEle = undefined;
    shiftTypeNote = undefined;
    pubUnpubButtonEle = undefined;
    newShiftButtonEle = undefined;

    // DATA
    schedules = undefined;
    appointments = undefined;
    calendarEvents = undefined;
    calendarAppointments = undefined;
    locations = undefined;
    employees = undefined;
    rosterCache = {};

    // GLOBALS
    currentCalView = undefined;
    selectedLocationId = undefined;
    selectedEmployeeId = undefined;
    selectedShiftType = undefined;
    viewOptionShifts = undefined;

    // Shift Popups
    SchedulingShifts.reset();
  }
  async function init() {
    resetModule();

    console.clear();

    currentCalView = 'month';
    viewOptionShifts = 'no';
    selectedEmployeeId = $.session.PeopleId;
    selectedLocationId = '%';

    ScheduleCalendar = new Calendar({
      defaultView: currentCalView,
      onEventClick: handleCalendarEventClick,
      onViewChange(newView) {
        currentCalView = newView;
      },
      onEventRender(eventsInView) {
        const unpublishedEvents = eventsInView.filter(
          event => !event.publishedDate && event.typeId !== 6,
        );
        updateShiftTypeNote(unpublishedEvents.length);
      },
    });

    build();

    try {
      const [employeesResp, locationsResp, appointmentsResp] = await Promise.all([
        _UTIL.fetchData('getAllEmployees', { userId: $.session.UserId }),
        _UTIL.fetchData('getLocationDropdownForSchedulingNew', { showOpenShifts: 'N' }),
        getCalendarAppointments(selectedLocationId),
      ]);

      employees = employeesResp.getAllEmployeesResult;
      locations = locationsResp.getLocationDropdownForSchedulingNewResult;
      calendarAppointments = appointmentsResp;
      calendarEvents = await getCalendarEvents(selectedLocationId, selectedEmployeeId);

      populateEmployeeDropdown();
      populateLocationDropdown();
      renderCalendarEvents();
    } catch (error) {
      employees = [];
      locations = [];
      calendarEvents = [];
      calendarAppointments = [];
    }

    if (viewOptionShifts === 'no') {
      const filterCheck = value => value !== 3 && value !== 4;
      ScheduleCalendar.filterEventsBy({ filterKey: 'typeId', filterCheck });
    }

    SchedulingShifts.init({
      ScheduleCalendar,
    });
  }

  return {
    init,
    renderCalendarEvents,
    getAppointments: () => appointments,
    fetchCalendarEvents: async () => {
      const [eventsResp, appointmentsResp] = await Promise.all([
        getCalendarEvents(selectedLocationId, selectedEmployeeId),
        getCalendarAppointments(selectedLocationId),
      ]);

      calendarEvents = eventsResp;
      calendarAppointments = appointmentsResp;
    },
    getCalendarEventData: () => calendarEvents,
    getSchedules: () => schedules,
    getLocations: () => locations,
    getSelectedLocationId: () => selectedLocationId,
    getSelectedEmployeeId: () => selectedEmployeeId,
    abbreviateAppointment,
  };
})();
